import { FieldModel } from '@cibo/core'
import { Box, Stack, Tooltip, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { LandThumbnail, LandThumbnailSkin } from '../../../components/LandThumbnail'

type BulkEditHeaderProps = {
  fieldModels?: FieldModel[]
}

const THUMBNAIL_SIZE = 80
const THUMBNAIL_LIMIT = 5

export const BulkEditHeader = ({ fieldModels }: BulkEditHeaderProps) => {
  const { t } = useTranslation('@cibo/landmanager/DetailEditing')

  return (
    <Stack direction="row" ml={6} position="relative" spacing={2} alignItems="center">
      <Box>
        {fieldModels
          ?.slice(0, THUMBNAIL_LIMIT)
          .reverse()
          .map((fieldModel, index) => (
            <Tooltip key={fieldModel.resourceId} title={fieldModel.name}>
              <Box
                style={{ width: THUMBNAIL_SIZE, height: THUMBNAIL_SIZE }}
                sx={{
                  marginLeft: -6,
                  float: 'left',
                  zIndex: THUMBNAIL_LIMIT - index,
                  backgroundColor: 'background.paper',
                  borderRadius: 1,
                  overflow: 'hidden',
                  position: 'relative',
                  boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.25)',
                  '&:hover': {
                    zIndex: THUMBNAIL_LIMIT + 1,
                    '> img': {
                      opacity: 1,
                    },
                  },
                  '> img': {
                    opacity: 1 - index / (fieldModels?.length ?? 1),
                  },
                  '&:first-of-type': {
                    marginLeft: 0,
                  },
                }}
              >
                <LandThumbnail
                  field={fieldModel}
                  width={THUMBNAIL_SIZE}
                  height={THUMBNAIL_SIZE}
                  skin={LandThumbnailSkin.SMALL}
                />
              </Box>
            </Tooltip>
          ))}
      </Box>
      {fieldModels && fieldModels.length > THUMBNAIL_LIMIT && (
        <Tooltip
          title={fieldModels.slice(THUMBNAIL_LIMIT).map(fieldModel => (
            <div key={fieldModel.resourceId}>{fieldModel.name}</div>
          ))}
        >
          <Typography color="text.secondary">
            {t('moreFields', {
              count: fieldModels?.length - THUMBNAIL_LIMIT,
            })}
          </Typography>
        </Tooltip>
      )}
    </Stack>
  )
}
